/**
 * @generated SignedSource<<531b8d95c50416551d0aaf5344653bb2>>
 * @relayHash 079002dd2850b17731228d06eb2c98f0
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 079002dd2850b17731228d06eb2c98f0

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UrlResponse",
    "kind": "LinkedField",
    "name": "dumpUsers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DumpUsersMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DumpUsersMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": "079002dd2850b17731228d06eb2c98f0",
    "metadata": {},
    "name": "DumpUsersMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "a51bc40bd5473dc97258deca84af5d52";

export default node;
